import { posthog } from "posthog-js";
import { isIOS, isNative } from "@core/plugins/mobile";
import { UserStorageManager } from "@core/managers/user-storage.manager";
import { KochavaManager } from "@core/managers/kochava.manager";
import { FirebaseManager } from "@core/plugins/firebase/firebase.manager";
import { EventManager } from "@core/managers/event.manager";
import { Logger } from "@core/helpers/logger.helpers";

// Event constants
export const COOKIE_CONSENT_EVENTS = {
  SHOW_BANNER: "cookie_consent:show_banner",
  UPDATE_CONSENT: "cookie_consent:update_consent",
};

export const COOKIE_CONSENT_STATUS = {
  DENIED: "denied",
  GRANTED: "granted",
};

export class CookieConsentManager {
  static async shouldShowCookieBanner() {
    if (!isNative) return false;
    try {
      const cookieKey = posthog.consent.storageKey;
      const cookie = await UserStorageManager.getCookie(cookieKey);
      if (isIOS) {
        const { status } = await KochavaManager.getAttStatus();
        return !cookie && cookie !== 0 && status === "authorized";
      }

      return !cookie && cookie !== 0;
    } catch (error) {
      Logger.error("Error checking cookie consent status:", error);
      return false;
    }
  }

  static async updateConsent(consent) {
    try {
      const cookieValue = consent ? 1 : 0;
      await UserStorageManager.setCookie(posthog.consent.storageKey, cookieValue);

      if (isNative) {
        FirebaseManager.updateConsent(consent ? COOKIE_CONSENT_STATUS.GRANTED : COOKIE_CONSENT_STATUS.DENIED);
      }

      EventManager.emit(COOKIE_CONSENT_EVENTS.UPDATE_CONSENT, consent);

      return true;
    } catch (error) {
      Logger.error("Error updating cookie consent:", error);
      return false;
    }
  }

  static async checkAndShowBanner() {
    try {
      const shouldShow = await this.shouldShowCookieBanner();
      if (shouldShow) {
        EventManager.emit(COOKIE_CONSENT_EVENTS.SHOW_BANNER);
      }
      return shouldShow;
    } catch (error) {
      Logger.error("Error in checkAndShowBanner:", error);
      return false;
    }
  }
}

export default CookieConsentManager;
